/**
 * Lowest Price badge + native Shopify contact form modal.
 *
 * Desktop:
 *   - Tooltip opens on hover.
 *
 * Tablet / Mobile:
 *   - Tooltip opens on click.
 *
 * Modal:
 *   - Opens from Lowest Price button on a PDP.
 *   - Opens from any "#claim-form" link (rich text, pages, footer).
 *   - Uses Shopify native contact form.
 *   - Prevents page reload.
 *   - Shows success toast after submission.
 */

(function () {
  'use strict';


  /* =========================================================
     ELEMENTS
     ========================================================= */

  var modal = document.querySelector(
    '[data-lowest-price-modal]'
  );

  var toast = document.querySelector(
    '[data-lowest-price-toast]'
  );


  /*
    If modal doesn't exist, there is nothing
    for this script to do.
  */

  if (!modal) {
    return;
  }


  var form = modal.querySelector(
    '#LowestPriceContactForm'
  );


  var lastTrigger = null;


  /* =========================================================
     DEVICE DETECTION
     ========================================================= */

  function isDesktopHoverDevice() {

    return window.matchMedia(
      '(min-width: 990px) and (hover: hover) and (pointer: fine)'
    ).matches;

  }


  /* =========================================================
     TOOLTIP HELPERS
     ========================================================= */

  function getTooltipFromInfoButton(infoBtn) {

    var badge = infoBtn.closest(
      '[data-lowest-price-badge]'
    );


    if (!badge) {
      return null;
    }


    return badge.querySelector(
      '[data-lowest-price-tooltip]'
    );
  }


  function closeAllTooltips() {

    document
      .querySelectorAll(
        '[data-lowest-price-tooltip]'
      )
      .forEach(function (tooltip) {

        tooltip.hidden = true;

        tooltip.classList.remove(
          'is-open'
        );

        tooltip.classList.remove(
          'is-hover'
        );

      });


    document
      .querySelectorAll(
        '[data-lowest-price-info-toggle]'
      )
      .forEach(function (button) {

        button.setAttribute(
          'aria-expanded',
          'false'
        );

      });

  }


  /* =========================================================
     DESKTOP TOOLTIP
     ========================================================= */


  /*
    Mouse enters info button.
  */

  document.addEventListener(
    'mouseenter',
    function (event) {

      if (!isDesktopHoverDevice()) {
        return;
      }


      var infoBtn = event.target.closest(
        '[data-lowest-price-info-toggle]'
      );


      if (!infoBtn) {
        return;
      }


      var tooltip =
        getTooltipFromInfoButton(infoBtn);


      if (!tooltip) {
        return;
      }


      /*
        Close other tooltips.
      */

      document
        .querySelectorAll(
          '[data-lowest-price-tooltip]'
        )
        .forEach(function (item) {

          if (item !== tooltip) {

            item.hidden = true;

            item.classList.remove(
              'is-hover'
            );

          }

        });


      /*
        Open this tooltip.
      */

      tooltip.hidden = false;

      tooltip.classList.add(
        'is-hover'
      );


      infoBtn.setAttribute(
        'aria-expanded',
        'true'
      );

    },

    true
  );


  /*
    Mouse leaves info button.

    We don't immediately close it because
    the mouse may be moving into the tooltip.
  */

  document.addEventListener(
    'mouseleave',
    function (event) {

      if (!isDesktopHoverDevice()) {
        return;
      }


      var infoBtn = event.target.closest(
        '[data-lowest-price-info-toggle]'
      );


      if (!infoBtn) {
        return;
      }


      var tooltip =
        getTooltipFromInfoButton(infoBtn);


      if (!tooltip) {
        return;
      }


      setTimeout(function () {

        /*
          Keep it open if mouse is over either
          the button or the tooltip.
        */

        var badge =
          infoBtn.closest(
            '[data-lowest-price-badge]'
          );


        if (
          badge &&
          badge.matches(':hover')
        ) {
          return;
        }


        if (
          tooltip.matches(':hover')
        ) {
          return;
        }


        tooltip.hidden = true;

        tooltip.classList.remove(
          'is-hover'
        );

        infoBtn.setAttribute(
          'aria-expanded',
          'false'
        );

      }, 100);

    },

    true
  );


  /*
    Mouse enters tooltip.

    Keep tooltip visible.
  */

  document.addEventListener(
    'mouseenter',
    function (event) {

      if (!isDesktopHoverDevice()) {
        return;
      }


      var tooltip = event.target.closest(
        '[data-lowest-price-tooltip]'
      );


      if (!tooltip) {
        return;
      }


      tooltip.hidden = false;

      tooltip.classList.add(
        'is-hover'
      );

    },

    true
  );


  /*
    Mouse leaves tooltip.
  */

  document.addEventListener(
    'mouseleave',
    function (event) {

      if (!isDesktopHoverDevice()) {
        return;
      }


      var tooltip = event.target.closest(
        '[data-lowest-price-tooltip]'
      );


      if (!tooltip) {
        return;
      }


      setTimeout(function () {

        if (
          tooltip.matches(':hover')
        ) {
          return;
        }


        var badge =
          tooltip.closest(
            '[data-lowest-price-badge]'
          );


        if (
          badge &&
          badge.matches(':hover')
        ) {
          return;
        }


        tooltip.hidden = true;

        tooltip.classList.remove(
          'is-hover'
        );


        var infoBtn =
          badge
            ? badge.querySelector(
                '[data-lowest-price-info-toggle]'
              )
            : null;


        if (infoBtn) {

          infoBtn.setAttribute(
            'aria-expanded',
            'false'
          );

        }

      }, 100);

    },

    true
  );


  /* =========================================================
     TABLET / MOBILE TOOLTIP CLICK
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /*
        Desktop uses hover.

        Do not run click tooltip behavior
        on desktop.
      */

      if (isDesktopHoverDevice()) {
        return;
      }


      var infoBtn = event.target.closest(
        '[data-lowest-price-info-toggle]'
      );


      if (!infoBtn) {
        return;
      }


      /*
        Prevent the button from doing anything
        else.
      */

      event.preventDefault();

      event.stopPropagation();


      var tooltip =
        getTooltipFromInfoButton(infoBtn);


      if (!tooltip) {
        return;
      }


      var wasOpen =
        tooltip.classList.contains(
          'is-open'
        );


      /*
        Close all other tooltips.
      */

      closeAllTooltips();


      /*
        If it wasn't open, open it.
      */

      if (!wasOpen) {

        tooltip.hidden = false;

        tooltip.classList.add(
          'is-open'
        );


        infoBtn.setAttribute(
          'aria-expanded',
          'true'
        );

      }

    }
  );


  /* =========================================================
     TOOLTIP CLOSE BUTTON
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var closeBtn = event.target.closest(
        '[data-lowest-price-tooltip-close]'
      );


      if (!closeBtn) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      var tooltip = closeBtn.closest(
        '[data-lowest-price-tooltip]'
      );


      if (!tooltip) {
        return;
      }


      tooltip.hidden = true;

      tooltip.classList.remove(
        'is-open'
      );

      tooltip.classList.remove(
        'is-hover'
      );


      var badge =
        tooltip.closest(
          '[data-lowest-price-badge]'
        );


      var infoBtn =
        badge
          ? badge.querySelector(
              '[data-lowest-price-info-toggle]'
            )
          : null;


      if (infoBtn) {

        infoBtn.setAttribute(
          'aria-expanded',
          'false'
        );

      }

    }
  );


  /* =========================================================
     CLICK OUTSIDE TOOLTIP
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /*
        Desktop doesn't use click to control
        tooltip.
      */

      if (isDesktopHoverDevice()) {
        return;
      }


      /*
        If click happened inside a badge,
        don't close it.
      */

      if (
        event.target.closest(
          '[data-lowest-price-badge]'
        )
      ) {
        return;
      }


      closeAllTooltips();

    }
  );


  /* =========================================================
     ESCAPE CLOSES TOOLTIP
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') {
        return;
      }


      closeAllTooltips();

    }
  );


  /* =========================================================
     OPEN MODAL

     badge = the Lowest Price badge on a PDP,
             or null when opened from a content
             link such as "Claim form".
     ========================================================= */

  function openModal(badge) {

    var productName = badge
      ? badge.getAttribute(
          'data-product-title'
        )
      : '';


    var productUrl = badge
      ? badge.getAttribute(
          'data-product-url'
        )
      : '';


    var nameField =
      modal.querySelector(
        '[data-lp-product-name]'
      );


    var urlField =
      modal.querySelector(
        '[data-lp-product-url]'
      );


    /*
      Product name.

      Locked when we already know the product.
      Editable when the modal is opened from a
      content page, where there is no product.
    */

    if (nameField) {

      nameField.value =
        productName || '';

      nameField.readOnly =
        !!productName;

    }


    /*
      Product URL.

      Same rule as the name field.
    */

    if (urlField) {

      urlField.value =
        productUrl || '';

      urlField.readOnly =
        !!productUrl;

    }


    /*
      Close any tooltip before opening
      the modal.
    */

    closeAllTooltips();


    /*
      Show modal.
    */

    modal.hidden = false;


    /*
      Prevent page scrolling.
    */

    document.documentElement.classList.add(
      'lowest-price-modal-open'
    );

    document.body.classList.add(
      'lowest-price-modal-open'
    );


    /*
      Remember trigger.
    */

    lastTrigger =
      document.activeElement;


    /*
      Focus the first field the customer
      actually has to fill in.
    */

    var firstInput =
      modal.querySelector(
        urlField && !urlField.value
          ? '#LowestPriceOurLink'
          : '#LowestPriceOtherLink'
      );


    if (firstInput) {

      setTimeout(function () {

        firstInput.focus();

      }, 50);

    }


    /*
      Escape closes modal.
    */

    document.addEventListener(
      'keydown',
      onModalKeydown
    );

  }


  /* =========================================================
     CLOSE MODAL
     ========================================================= */

  function closeModal() {

    modal.hidden = true;


    document.documentElement.classList.remove(
      'lowest-price-modal-open'
    );

    document.body.classList.remove(
      'lowest-price-modal-open'
    );


    document.removeEventListener(
      'keydown',
      onModalKeydown
    );


    /*
      Return focus.
    */

    if (
      lastTrigger &&
      typeof lastTrigger.focus ===
        'function'
    ) {

      lastTrigger.focus();

    }

  }


  /* =========================================================
     MODAL ESCAPE
     ========================================================= */

  function onModalKeydown(event) {

    if (event.key === 'Escape') {

      closeModal();

    }

  }


  /* =========================================================
     SUCCESS TOAST
     ========================================================= */

  function showToast() {

    if (!toast) {
      return;
    }


    toast.hidden = false;


    clearTimeout(
      showToast.timer
    );


    showToast.timer =
      setTimeout(function () {

        toast.hidden = true;

      }, 6000);

  }


  /* =========================================================
     ERROR
     ========================================================= */

  function showError(message) {

    var errorEl =
      modal.querySelector(
        '[data-lowest-price-error]'
      );


    /*
      Create error element if it doesn't
      already exist.
    */

    if (!errorEl) {

      errorEl =
        document.createElement(
          'div'
        );


      errorEl.className =
        'lowest-price-modal__error';


      errorEl.setAttribute(
        'role',
        'alert'
      );


      var modalForm =
        modal.querySelector(
          'form'
        );


      if (modalForm) {

        modalForm.insertBefore(
          errorEl,
          modalForm.firstChild
        );

      }

    }


    errorEl.textContent =
      message;


    errorEl.hidden = false;

  }


  /* =========================================================
     MODAL CLICK HANDLER
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /*
        Open Lowest Price modal.
      */

      var openBtn =
        event.target.closest(
          '[data-lowest-price-open]'
        );


      if (openBtn) {

        var badge =
          openBtn.closest(
            '[data-lowest-price-badge]'
          );


        openModal(badge);

        return;

      }


      /*
        Close modal.
      */

      var closeBtn =
        event.target.closest(
          '[data-lowest-price-close]'
        );


      if (closeBtn) {

        closeModal();

        return;

      }


      /*
        Close toast.
      */

      var toastClose =
        event.target.closest(
          '[data-lowest-price-toast-close]'
        );


      if (toastClose) {

        if (toast) {

          toast.hidden = true;

        }

        return;

      }

    }
  );


  /* =========================================================
     CLAIM FORM LINK

     Rich text fields strip custom attributes,
     so content links point at "#claim-form"
     and we catch them here.
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var el = event.target;


      if (!el || !el.closest) {
        return;
      }


      var link = el.closest(
        'a[href*="#claim-form"]'
      );


      if (!link) {
        return;
      }


      event.preventDefault();


      openModal(null);

    }
  );


  /*
    Someone landed on the page with
    #claim-form already in the URL.
  */

  if (
    window.location.hash === '#claim-form'
  ) {

    openModal(null);

  }


  /* =========================================================
     SHOPIFY CONTACT FORM
     ========================================================= */

  if (form) {

    /*
      IMPORTANT:

      Capture phase = TRUE

      This lets us intercept the form submission
      before other theme scripts can handle it.
    */

    document.addEventListener(
      'submit',
      function (event) {

        var submittedForm =
          event.target;


        /*
          Only handle our Lowest Price form.
        */

        if (
          !submittedForm ||
          submittedForm.id !==
            'LowestPriceContactForm'
        ) {
          return;
        }


        console.log(
          '[Lowest Price] Submit intercepted'
        );


        /*
          STOP NORMAL SHOPIFY PAGE NAVIGATION.
        */

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        /*
          Browser validation.
        */

        if (
          !submittedForm.checkValidity()
        ) {

          submittedForm.reportValidity();

          return;

        }


        /*
          Submit button.
        */

        var submitBtn =
          submittedForm.querySelector(
            '[data-lowest-price-submit]'
          );


        if (submitBtn) {

          submitBtn.disabled = true;

          submitBtn.classList.add(
            'is-loading'
          );

        }


        /*
          Shopify generates the action
          automatically for:

          {% form 'contact' %}
        */

        var submitUrl =
          submittedForm.getAttribute(
            'action'
          );


        if (!submitUrl) {

          showError(
            'Unable to submit the form. Please refresh the page and try again.'
          );


          if (submitBtn) {

            submitBtn.disabled = false;

            submitBtn.classList.remove(
              'is-loading'
            );

          }


          return;

        }


        /*
          Convert relative URL to absolute URL.
        */

        var absoluteSubmitUrl =
          new URL(
            submitUrl,
            window.location.origin
          ).href;


        console.log(
          '[Lowest Price] Shopify URL:',
          absoluteSubmitUrl
        );


        /*
          Build FormData.
        */

        var formData =
          new FormData(
            submittedForm
          );


        /*
          Submit to Shopify.
        */

        fetch(
          absoluteSubmitUrl,
          {
            method: 'POST',

            body: formData,

            credentials: 'same-origin',

            redirect: 'follow',

            headers: {
              'Accept':
                'text/html,application/xhtml+xml'
            }
          }
        )


        .then(function (response) {

          console.log(
            '[Lowest Price] Response:',
            response.status,
            response.url
          );


          /*
            Shopify normally responds with a
            successful HTTP status.

            We don't navigate to that response.
          */

          if (
            response.status < 200 ||
            response.status >= 300
          ) {

            throw new Error(
              'Shopify returned HTTP ' +
              response.status
            );

          }


          return response;

        })


        .then(function () {

          console.log(
            '[Lowest Price] Submission successful'
          );


          /*
            Close modal.
          */

          closeModal();


          /*
            Reset fields.
          */

          submittedForm.reset();


          /*
            Show green popup.
          */

          showToast();

        })


        .catch(function (error) {

          console.error(
            '[Lowest Price] Submission error:',
            error
          );


          showError(
            'Something went wrong. Please try again in a moment.'
          );

        })


        .finally(function () {

          if (submitBtn) {

            submitBtn.disabled = false;

            submitBtn.classList.remove(
              'is-loading'
            );

          }

        });

      },

      /*
        CAPTURE PHASE
      */

      true
    );

  }


  /* =========================================================
     T&C TOGGLE
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var toggle = event.target.closest(
        '[data-lowest-price-terms-toggle]'
      );

      if (!toggle) {
        return;
      }

      event.preventDefault();

      var terms = toggle.closest(
        '.lowest-price-modal__terms'
      );

      if (!terms) {
        return;
      }

      var content = terms.querySelector(
        '[data-lowest-price-terms-content]'
      );

      if (!content) {
        return;
      }

      var label = toggle.querySelector(
        '[data-lowest-price-terms-label]'
      );

      var isOpen =
        toggle.getAttribute('aria-expanded') === 'true';


      if (isOpen) {

        /* CLOSE */

        toggle.setAttribute(
          'aria-expanded',
          'false'
        );

        toggle.classList.remove('active');

        content.hidden = true;

        if (label) {
          label.textContent = 'View T&C';
        }

      } else {

        /* OPEN */

        toggle.setAttribute(
          'aria-expanded',
          'true'
        );

        toggle.classList.add('active');

        content.hidden = false;

        if (label) {
          label.textContent = 'Hide T&C';
        }

      }

    }
  );

})();
